import React, { useMemo } from "react";
import { ProductCard } from "../ProductCard";
import { GridContainer } from "./ProductsListElements";
import { Reveal } from "../../general/Reveal";
import { isDateInFuture } from "../../../utils";

const hasActiveDiscount = (product) =>
  (product.sizes || []).some((size) => isDateInFuture(size.validUntil));

const ProductsList = ({ products }) => {
  // Discounted products first.
  const sortedProducts = useMemo(
    () =>
      [...products].sort(
        (a, b) => Number(hasActiveDiscount(b)) - Number(hasActiveDiscount(a))
      ),
    [products]
  );

  return (
    <GridContainer>
      {sortedProducts.map((product, index) => (
        <Reveal key={product._id} delay={(index % 4) * 0.08}>
          <ProductCard product={product} />
        </Reveal>
      ))}
    </GridContainer>
  );
};

export default ProductsList;
